
const digest = '095524a3d5eb9d10a81aaac7f327f57d0e2535a806076348d9141562fe308137';
const css = `._elementToolbarReferenceElement_1geoq_1 {
  display: inline-block;
  max-width: 100%;
}
._elementToolbarReferenceElement_1geoq_1._inline_1geoq_5 {
  display: inline;
  /*
   * Special override where inline-block won't work. We can't use inline-block
   * everywhere because of https://bugs.webkit.org/show_bug.cgi?id=105898
   * The problem is reproduced with the Link element where the up arrow doesn't
   * work when trying to move up from a link to the line above.
   */
}

._elementToolbarBlock_1geoq_15 {
  display: block;
}

._elementToolbarCommon_1geoq_19 {
  box-shadow: 0 0 var(--spacer-2) 0 rgba(0, 0, 0, 0.08);
  background-color: var(--theme-primary-background);
  border: 1px solid var(--theme-light-border);
  border-radius: 4px;
  padding: 2px;
}

._elementToolbar_1geoq_1 {
  overflow: visible;
  display: flex;
  flex-direction: row;
  margin-top: -4px; /* To keep the toolbar from touching the bottom of the screen when scrolling. */

  /*
   * Styling of buttons and other controls in this toolbar.
   * Note that toolbar, elementToolbar and selectionToolbar all use the same
   * components with different variable settings.
   */

  --editor-v2-toolbar-button-font-size: 13px;
  --theme-editor-button-hovered: var(--aha-gray-200);
}

._elementToolbarButtonText_1geoq_43 {
  font-size: 12px;
  padding: 0 5px;
  display: flex;
  align-items: center;
  gap: 5px;
}

._elementToolbarModal_1geoq_51 {
  display: flex;
  flex-direction: row;
}
._elementToolbarModalContainer_1geoq_55 {
  margin: 2px;
  display: flex;
  align-items: center;
}

._submenuIcons_1geoq_61 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

._submenuListToggle_1geoq_67 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-width: 200px;
  margin-left: var(--aha-menu-content--horizontal-padding);
  margin-right: var(--aha-menu-content--horizontal-padding);
}

._submenuListToggleDivider_1geoq_77 {
  border-top: 1px solid var(--theme-light-border);
  margin: var(--spacer-1);
}

._submenuListToggleItem_1geoq_82 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: calc(var(--spacer-3) / 2) var(--spacer-2);
  cursor: pointer;
  margin: 2px;
  border-radius: 4px;
}

._submenuListToggleItemDisabled_1geoq_93 {
  opacity: 0.3;
}

._submenuListToggleItemDanger_1geoq_97 {
  --editor-v2-toolbar-button-color: var(--theme-alert-danger-text);
  --theme-editor-button-hovered: var(--theme-alert-danger-background);
}

._submenuListToggleItemLabel_1geoq_102 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

._submenuListToggleItemIcon_1geoq_108 {
  color: var(--editor-v2-toolbar-button-color);
  margin-right: 8px;
}

._submenuListToggleItemText_1geoq_113 {
  color: var(--editor-v2-toolbar-button-color);
  font-size: 12px;
}

._submenuListToggleItem_1geoq_82:hover:not(._elementToolbarButtonDisabled_1geoq_118) {
  background-color: var(--theme-editor-button-hovered);
}
._submenuListToggleItem_1geoq_82:active:not(._elementToolbarButtonDisabled_1geoq_118) {
  color: var(--aha-blue-700);
  background-color: var(--aha-blue-300);
}

._elementToolbar_1geoq_1 aha-tooltip {
  --Tooltip__tooltip--font-size: 14px;
}

._hoverToolbarWrapper_1geoq_130 {
  position: relative;
}

._hoverToolbar_1geoq_130 {
  position: absolute;
  top: var(--spacer-2);
  right: var(--spacer-2);
  z-index: 11;
  opacity: 0;
  transition: opacity 0.3s;
}

._hoverToolbarWrapper_1geoq_130:hover ._hoverToolbar_1geoq_130 {
  opacity: 1;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"elementToolbarReferenceElement":"_elementToolbarReferenceElement_1geoq_1","inline":"_inline_1geoq_5","elementToolbarBlock":"_elementToolbarBlock_1geoq_15","elementToolbarCommon":"_elementToolbarCommon_1geoq_19","elementToolbar":"_elementToolbar_1geoq_1","elementToolbarButtonText":"_elementToolbarButtonText_1geoq_43","elementToolbarModal":"_elementToolbarModal_1geoq_51","elementToolbarModalContainer":"_elementToolbarModalContainer_1geoq_55","submenuIcons":"_submenuIcons_1geoq_61","submenuListToggle":"_submenuListToggle_1geoq_67","submenuListToggleDivider":"_submenuListToggleDivider_1geoq_77","submenuListToggleItem":"_submenuListToggleItem_1geoq_82","submenuListToggleItemDisabled":"_submenuListToggleItemDisabled_1geoq_93","submenuListToggleItemDanger":"_submenuListToggleItemDanger_1geoq_97","submenuListToggleItemLabel":"_submenuListToggleItemLabel_1geoq_102","submenuListToggleItemIcon":"_submenuListToggleItemIcon_1geoq_108","submenuListToggleItemText":"_submenuListToggleItemText_1geoq_113","elementToolbarButtonDisabled":"_elementToolbarButtonDisabled_1geoq_118","hoverToolbarWrapper":"_hoverToolbarWrapper_1geoq_130","hoverToolbar":"_hoverToolbar_1geoq_130"};
export { css, digest };
  